import { connect } from 'react-redux'
import { clearModal } from '@hixme/modal'
import { getWaiter } from 'redux-waiter'

// route modules
import HospitalIndemnityCoverageModal from '../components/HospitalIndemnityCoverageModal'
import { actions, constants, selectors } from '../modules/hospital-indemnity-coverage'

const mapStateToProps = (state) => {
  const persons = selectors.getAllPersons(state)
  const fields = persons.map((p) => p.Id)

  const initialValues = {}
  selectors.getSelectedPersons(state).forEach((person) => {
    initialValues[person.Id] = true
  })

  return {
    isProcessing: getWaiter(state, constants.GET_HOSPITAL_INDEMNITY).isPending,
    persons,
    fields,
    initialValues,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onCancelClick: () => dispatch(clearModal()),
  onSubmit: (values) =>
    new Promise((resolve, reject) => {
      const selectedIds = Object.keys(values).reduce((prev, curr) => {
        if (values[curr]) prev.push(curr)
        return prev
      }, [])
      dispatch(actions.setSelectedPersons(selectedIds))
      dispatch(actions.updateHospitalIndemnityWithCart()).then(
        () => {
          dispatch(clearModal())
          resolve()
        },
        () => {
          reject()
        }
      )
    }),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HospitalIndemnityCoverageModal)
